import { combine, createEffect, createEvent, createStore } from 'effector';
import { saveAs } from 'file-saver';
import { $notificationStore } from '../notificationStore';
import { TransferRequestsApi } from '@shared/api/rest';
import { TransferRequestDownloadDocumentRequest, TransferRequestDownloadDocumentResponse } from '@shared/api/rest/transferRequests';

const effect = createEffect((request: TransferRequestDownloadDocumentRequest) => TransferRequestsApi.downloadDocument(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestDownloadDocumentResponse | null>(null)
  .on(effect.done, (_, data) => data.result.data)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

effect.done.watch((result) => saveAs(`data:${result.result.data?.contentType};base64,${result.result.data?.data}`, result.result.data?.fileName));
effect.fail.watch((x) => $notificationStore.events.setError(x.error.message));

export const $downloadDocumentStore = {
  events: {
    download: effect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
  }),
};
